import { useState } from "react";
import MarketingSummary from "../../components/MarketingSummary";
import MarketingForm from "../../components/MarketingForm";
import { runMarketingDiagnostics } from "../../api/diagnosticsApi";
import { Loader2, Zap } from "lucide-react";

export default function MarketingTool() {
  const [report, setReport] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  async function runDiagnostic(answers: any) {
    setIsLoading(true);
    try {
      const data = await runMarketingDiagnostics(answers);
      setReport(data);
    } catch (err) {
      console.error("Error running marketing diagnostic:", err);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="min-h-screen pt-10 p-6 md:p-8 lg:p-10 md:ml-0">
      <header className={`mt-5 mb-8 flex items-center justify-between ${!report || isLoading ? "max-w-2xl mx-auto justify-center text-center" : ""}`}>
        <div>
          <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2 leading-tight mb-0">
            <Zap className="text-indigo-600" size={24} />
            {report && !isLoading ? "Diagnostic Results" : "Marketing Diagnostics"}
          </h1>
          <p className="text-slate-500 text-sm mt-1 text-left">
            {report && !isLoading 
              ? "Review your personalized marketing maturity and CRM health analysis below."
              : "Answer a few questions to evaluate your marketing maturity and CRM health."}
          </p>
        </div>
      </header>

      {!report && !isLoading && (
        <div className="max-w-2xl mx-auto">
          <MarketingForm onSubmit={runDiagnostic} />
        </div>
      )}

      {isLoading && (
        <div className="flex flex-col items-center justify-center py-20 animate-pulse">
          <Loader2 className="w-12 h-12 text-pink-600 animate-spin mb-4" />
          <p className="text-slate-500 font-medium text-lg">Analyzing your marketing engine...</p>
        </div>
      )}

      {report && !isLoading && (
        <div className="mt-8">
          <MarketingSummary
            overallPercentage={report.overallPercentage}
            visualIndicator={report.visualIndicator || report.grade}
            categoryScores={report.categoryScores}
            report={report.summaryReport}
            recommendations={report.recommendations}
            services={report.ctaServices}
          />
        </div>
      )}
    </div>
  );
}
